import React from "react";

export default function TakeYourGame() {
  return (
    <>
      <section
        className="clients-section alternat-2 p_30 centred"
        style={{ backgroundColor: "#071522" }}
      >
        <div className="auto-container">
          <div className="inner-container">
            <h1 className="text-white">Take Your Game to the Next Level</h1>
            <p className="text-white py-3">
              With Xeer Technology’s Crypto Gaming App Development services,
              bring a new level of engagement and monetization to your games.
              Join the future of gaming today—contact us to discuss your
              project!
            </p>
          </div>
          <a href="/contact-us" className="theme-btn btn-one mr_20">
            Get a quote
          </a>
        </div>
      </section>
    </>
  );
}
